export default __webpack_public_path__ + "static/media/num1.bcdaac40.png";